// Shared i18n-js instance.
//
// i18n-js v4 removed the module-level singleton that v3 exported as its default
// import (`import I18n from "i18n-js"`). Instead you construct an `I18n`
// instance. The app relies on a single shared instance — `window.I18n` for the
// legacy EUI/CoffeeScript code, and the codegen'd translations blob
// (src/js/generated/i18n_translations.js) which calls `.store()` on it. Both
// import THIS module so they share one instance.
import { I18n } from "i18n-js";

const i18n = new I18n();

export default i18n;
